import Stack from '@mui/material/Stack'
import { useStoreState } from '../../../../store/hooks'
import ColorToMove from '../../components/ColorToMove'
import DailyPuzzleButtons from '../components/DailyPuzzleButtons'
import DailyPuzzleControls from '../components/DailyPuzzleControls'

const MobileDP: React.FC = () => {
    const myColor = useStoreState((state) => state.dailyPuzzleViewV2.myColor)

    return (
        <Stack alignItems="center" spacing="8px">
            {/* Color to move / Buttons */}
            <DailyPuzzleButtons>
                <ColorToMove playerColor={myColor} />
            </DailyPuzzleButtons>
            {/* Controls */}
            <DailyPuzzleControls />
        </Stack>
    )
}

export default MobileDP
